import React, { useState, useEffect, createContext,useContext } from "react";
import SglContext from "../SglContext";
import {Link, useNavigate} from 'react-router-dom';
import axios from "axios";
import './classSignups.css'
import {useSearchParams } from 'react-router-dom';
function ClassSignupDetail(props){
    const [class_details, setClass_details] = useState({})
    const [class_group, setClass_group] = useState({})
    const [order_of_go_set_count, setOrder_of_go_set_count] = useState(0)
    const [entry_x_classes, setEntry_x_classes] = useState([])
    const [current_show, setCurrent_show] = useState(sgl_show_id)
    const [userData, setUserData] = useState({})
    const [loading, setLoading] = useState(true)
    
    const navigate = useNavigate();
    const[searchParam,setSearchParam]=useSearchParams()
    const Sgl = useContext(SglContext)
    const sgl_webservice_class_signups_detail = Sgl.nestApiUrl+'/classsignup/';
    const user_info_url = Sgl.nestApiUrl + "/users/getUser";
    const page_url ="//" +window.location.host +"/" + window.location.pathname +window.location.search;


    var sgl_show_id = (sgl_show_id && sgl_show_id != '')?sgl_show_id:localStorage.getItem('show_id');
    
    

    useEffect(() => { 
        getEntryDetails();
    }, [])
    
    
    function getEntryDetails(){
        document.title = "Class Signups";
        getUserData();
        axios.all([
            axios.get(sgl_webservice_class_signups_detail+searchParam.get('cgid'),{
                params : {
                    eid: searchParam.get('cgid'),
                    show_id: sgl_show_id,
                    customer_id: Sgl.company_id
                }
                })
            ]).then(axios.spread((res) => {
                setClass_details(res.data.class_data)
                setClass_group(res.data.class_group)
                setOrder_of_go_set_count(res.data.order_of_go_set_count)
                setEntry_x_classes(res.data.entry_x_classes)
                setLoading(false)
            }))

    }

    function getUserData(){
        axios.get(user_info_url)
        .then((response) => {
          if(response.data.user && response.data.user != null){
            setUserData(response.data.user)
          }else{
          }
        }, (error) => {
        });
    }

    function format_date(unformatted_date){
      var unformatted_date_split = (unformatted_date && unformatted_date.split)?unformatted_date.split('T')[0]:unformatted_date;
      var formatted_date = (new Date(unformatted_date_split));
      formatted_date = new Date(formatted_date.toISOString().slice(0, -1));
      return parseInt(formatted_date.getMonth()+1) +"/"+ formatted_date.getDate() +"/"+ formatted_date. getFullYear()%100;
    }
    function getParamDate(date_value){
        if(date_value != '' && date_value != "0000-00-00"){
            date_value = date_value.split('T')[0];
            return '?date='+date_value;
        }
        return;
    }

    function format_time(timeString){
      var H = +timeString.substr(0, 2);
      var h = H % 12 || 12;
      var ampm = (H < 12 || H === 24) ? " AM" : " PM";
      timeString = h + timeString.substr(2, 3) + ampm;
      return timeString;
    }

    function onShowChange(show_id) {
        localStorage.setItem('show_id', show_id);
        window.location.href=page_url;
    }

        if(loading) {
          return null;
        }
        
        return(
            <div className="sgl-plugin section-to-print classSignupDetailsCss" >
                <h2>View Set Order - {class_group.group_name} {((class_details.sponsor) ? <span className='sponsor_text'> (Sponsored By: {class_details.sponsor})</span>:"")}</h2>
                {(order_of_go_set_count == 0) &&
                    <p>Order of Go Not Yet Set. Check back for updated orders.</p>
                }
                {(class_details.class_type == "Jumpers") ?
                    <p><span className="grid-heading class_jumper_table link_color">{class_details.jumper_table}</span></p>
                :
                    <p><span className="grid-heading class_jumper_table link_color">{class_details.hunter_type}</span></p>
                }
                <button className='button sgl-button' 
                    onClick={(e) => {
                        e.preventDefault();
                        navigate("/orders-of-go-signups"+getParamDate(class_group.day));
                    }}
                >
                    Back to Listing View
                </button>
              
                { entry_x_classes.length > 0 &&
                    <div className="div-responsive">
                        <table className="table table-striped">
                            <thead className="classes-header">
                                <tr>
                                    <th colspan="8" className='link_color'>ORDER OF GO</th>
                                </tr>
                            </thead>
                            <tbody>
                            <tr className="sgl-primary-header">
                                <th nowrap="nowrap" className='center-align'>Order</th>
                                <th nowrap="nowrap" className='center-align'>Entry</th>
                                <th nowrap="nowrap" className='center-align'>Class</th>
                                <th nowrap="nowrap" className='center-align'>Horse</th>
                                <th nowrap="nowrap" className='center-align'>Rider</th>
                                <th nowrap="nowrap" className='center-align'>Trainer</th>

                            </tr>
                            {
                                entry_x_classes
                                .sort((a, b) => (a.order_of_go === 0) - (b.order_of_go === 0) || a.order_of_go - b.order_of_go)
                                .map((data,index) => { 
                                return(
                                    <tr key={index}>
                                        <td className='center-align'>{((data.order_of_go==0 || data.order_of_go=="") ? "" : index+1)}</td>
                                        <td className='center-align'>{data.entry_number}</td>
                                        <td className='center-align'>{data.class_number}</td>
                                        <td>{data.horse}</td>
                                        <td>{data.rider_name}</td>
                                        <td>{data.trainer}</td>

                                    </tr>
                                )
                                })
                            }
                            </tbody>
                        </table>
                    </div>
                }
            </div>
        )
}
export default ClassSignupDetail